import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/css3': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M480 32L416 400 192.7 480 0 400 19.6 305.2H101.6L93.6 345.8 210 390.2 344.1 345.8 362.9 248.7H29.5L45.5 166.7H379.2L389.7 114H56.3L72.6 32H480z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/css3.js
// module id = a5FI
// module chunks = 144